<template>
  <layout title="Subscription">
    <div class="flex justify-center">
      <div class="md:p-8 p-4 !pb-28 max-w-7xl w-full flex items-stretch">
        <sideMenu page="apikey" />
        <div class="flex flex-col flex-1">
          <div class="flex flex-col md:ml-8 ml-4 max-w-sm">
            <div class="font-black text-3xl text-gray-800">Subscription</div>

            <div
              class="mt-6 bg-white shadow-allArround rounded-xl flex-1 relative"
              v-if="
                planLoading ||
                productLoading ||
                Object.keys(currPlan).length > 0
              "
            >
              <PuSkeleton
                class="h-full w-full z-10 rounded-xl absolute"
                v-if="planLoading || productLoading"
              />
              <div class="p-4 bg-gray-200 rounded-t-xl flex justify-between">
                <div class="font-bold text-xl">{{ product.name }} Plan</div>
                <div class="text-lg">
                  <p class="inline-block font-bold">
                    {{ product.price | price }}€
                  </p>
                  <p class="inline-block">/ {{ product.subscriptionTime }}</p>
                </div>
              </div>
              <div class="p-4 text-gray-800 overflow-hidden">
                <div class="flex justify-between mb-4" v-if="currPlan.subscription_id > 0">
                  <div>Next payment day</div>
                  <div>{{ currPlan.next_bill_date | formatDate }}</div>
                </div>
                <div class="flex items-center">
                  <div
                    class="btn-danger"
                    @click="toggleModal"
                  >
                    Cancel Subscription
                  </div>
                </div>
              </div>
            </div>
            <div
              class="
                mt-6
                shadow-allArround
                rounded-xl
                flex-1
                relative
              "
              v-if="
                currPlan.subscription_id > 0 &&
                (planLoading ||
                  productLoading ||
                  Object.keys(currPlan).length > 0)
              "
            >
              <PuSkeleton
                class="h-full w-full z-10 rounded-xl absolute"
                v-if="planLoading || productLoading"
              />
              <div class="p-4 bg-gray-200 rounded-t-xl">
                <div class="font-bold text-xl">Update Payment Method</div>
              </div>
              <div class="p-4 text-gray-800 overflow-hidden">
                <div>
                  Click the button below to update your default payment method.
                </div>
                <div class="mt-4 btn-primary w-auto" @click="updatePayment">
                  Update
                </div>
              </div>
            </div>
          </div>
          <div
            class="
              md:ml-8
              ml-4
              mt-6
              bg-white
              shadow-allArround
              rounded-xl
              flex-1
              relative
              p-4
              flex
              justify-center
              items-center
              flex-col
              text-center
            "
            v-if="
              !planLoading &&
              !productLoading &&
              Object.keys(currPlan).length === 0
            "
          >
            <div>Subscribe a plan to manage your subscription.</div>
            <inertia-link :href="$route('user.plans')" class="link mt-2"
              >Go to Plans</inertia-link
            >
          </div>
        </div>
      </div>
    </div>
    <modal
      :title="'Do you want to cancel ' + product.name + ' plan?'"
      type="danger"
      subtitle="You will no longer be able to use the service until you subscribe again."
      buttonTitle="Cancel Subscription"
      :show="showCancelModal"
      icon="exclamation-triangle"
      @closeModal="toggleModal"
      @actionClick="cancelSubscription"
    />
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/Layout/layout.vue");
const sideMenu = () =>
  import(
    /* webpackChunkName: "sideMenu" */ "../../Components/Layout/User/sideMenu.vue"
  );
const modal = () =>
  import(
    /* webpackChunkName: "sideMenu" */ "../../Components/modalConfirmMessage.vue"
  );
export default {
  components: { layout, sideMenu, modal },
  data() {
    return {
      currPlan: {},
      product: {},
      showCancelModal: null,
      planLoading: true,
      productLoading: true,
    };
  },
  mounted() {
    this.getPlan();
    this.getProduct();
  },
  methods: {
    getPlan() {
      this.axios
        .get("/user/api/plan")
        .then((response) => {
          if (response.data.plan_id) {
            this.currPlan = response.data;
          }
          this.planLoading = false;
        })
        .catch(() => {
          this.planLoading = false;
        });
    },
    getProduct() {
      this.axios
        .get("/user/api/product")
        .then((response) => {
          if (response.data.name) {
            this.product = response.data;
          }
          this.productLoading = false;
        })
        .catch(() => {
          this.productLoading = false;
        });
    },
    toggleModal() {
      this.showCancelModal = !this.showCancelModal;
    },
    cancelSubscription() {
      this.axios.post("/user/api/cancelsubscription").then((response) => {
        this.currPlan = {};
        this.product = {};
        this.$store.commit("showFlashMessage", {
          message: response.data.message,
          type: response.data.message_type,
        });
         this.toggleModal();
      });
    },
    updatePayment() {
      let self = this;
      Paddle.Checkout.open({
        override: this.currPlan.update_url,
        successCallback: function () {
          self.$store.commit("showFlashMessage", {
            message: "Your payment information was changed",
          });
        },
      });
    },
  },
};
</script>